import React, { SyntheticEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../App/Components/Button/Button'
import Spinner from '../../../App/Components/Spinner/Spinner'
import useLocalStorage from '../../../App/Hooks/useLocalStorage'
import { fetchEstablishmentAnonymous } from '../../../Establishment/DataStore/apiCalls'
import { IEstablishment } from '../../../Establishment/interface/IEstablishment'
import { InputField } from '../components/InputField'

import style from './style.scss'

type Props = {
  onSubmit: (establishment: IEstablishment) => void
}

const Establishment: React.FC<Props> = ({ onSubmit }) => {
  const optiosIdParameter = new URLSearchParams(window.location.search).get(
    'optios_id',
  )
  const [optiosId, setOptiosId] = useLocalStorage<string>(
    'last_optios_id',
    optiosIdParameter,
  )
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (null !== optiosIdParameter) {
      setOptiosId(optiosIdParameter)
    }
  }, [])

  const onFormSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (optiosId.length === 0) {
      setError('This value is required.')
      return
    }

    setLoading(true)
    fetchEstablishmentAnonymous(optiosId)
      .then(response => {
        setLoading(false)
        onSubmit(response.data)
      })
      .catch(() => {
        setError('Establishment not found')
        setLoading(false)
      })
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <div className={style.loginWrapper}>
      <form onSubmit={onFormSubmit}>
        <InputField
          onChange={e => setOptiosId(e.currentTarget.value)}
          placeholder={t('Uw Optios ID')}
          value={optiosId}
          error={error}
          autoFocus
          style={{ textAlign: 'center' }}
        />
        <Button type={'submit'}>{t('Next')}</Button>
      </form>
    </div>
  )
}

export default Establishment
